/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMatchingPolicyImpactPreviewDto
 */
export interface MdmMatchingPolicyImpactPreviewDto {
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    assetClass?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    activeGoldenRecordCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    pendingDuplicateCandidateCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    prospectiveOnly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    rematchJobAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    rematchJobImplemented?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    rematchSourceRecordCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchingPolicyImpactPreviewDto
     */
    rematchBatchCount?: number;
}

/**
 * Check if a given object implements the MdmMatchingPolicyImpactPreviewDto interface.
 */
export function instanceOfMdmMatchingPolicyImpactPreviewDto(value: object): value is MdmMatchingPolicyImpactPreviewDto {
    return true;
}

export function MdmMatchingPolicyImpactPreviewDtoFromJSON(json: any): MdmMatchingPolicyImpactPreviewDto {
    return MdmMatchingPolicyImpactPreviewDtoFromJSONTyped(json, false);
}

export function MdmMatchingPolicyImpactPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchingPolicyImpactPreviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'activeGoldenRecordCount': json['activeGoldenRecordCount'] == null ? undefined : json['activeGoldenRecordCount'],
        'pendingDuplicateCandidateCount': json['pendingDuplicateCandidateCount'] == null ? undefined : json['pendingDuplicateCandidateCount'],
        'prospectiveOnly': json['prospectiveOnly'] == null ? undefined : json['prospectiveOnly'],
        'message': json['message'] == null ? undefined : json['message'],
        'rematchJobAvailable': json['rematchJobAvailable'] == null ? undefined : json['rematchJobAvailable'],
        'rematchJobImplemented': json['rematchJobImplemented'] == null ? undefined : json['rematchJobImplemented'],
        'rematchSourceRecordCount': json['rematchSourceRecordCount'] == null ? undefined : json['rematchSourceRecordCount'],
        'rematchBatchCount': json['rematchBatchCount'] == null ? undefined : json['rematchBatchCount'],
    };
}

export function MdmMatchingPolicyImpactPreviewDtoToJSON(json: any): MdmMatchingPolicyImpactPreviewDto {
    return MdmMatchingPolicyImpactPreviewDtoToJSONTyped(json, false);
}

export function MdmMatchingPolicyImpactPreviewDtoToJSONTyped(value?: MdmMatchingPolicyImpactPreviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetClass': value['assetClass'],
        'activeGoldenRecordCount': value['activeGoldenRecordCount'],
        'pendingDuplicateCandidateCount': value['pendingDuplicateCandidateCount'],
        'prospectiveOnly': value['prospectiveOnly'],
        'message': value['message'],
        'rematchJobAvailable': value['rematchJobAvailable'],
        'rematchJobImplemented': value['rematchJobImplemented'],
        'rematchSourceRecordCount': value['rematchSourceRecordCount'],
        'rematchBatchCount': value['rematchBatchCount'],
    };
}

